/**
 * Build Plans Lesson
 * Skill Area: Operations
 * Generate project plans in hours, not days
 */

import type { LessonDefinition } from '../types';
import { BUILD_PLANS_AI_PROMPT } from '../prompts/build-plans.prompt';

export const buildPlans: LessonDefinition = {
  id: 'build-plans',
  title: 'Build Plans',
  displayTitle: 'Generate Project Plans in Hours, Not Days',
  subTitle: 'Generate project plans in hours',
  persona: 'Lyra',
  skillArea: 'Operations',
  topicId: 'programs-projects',
  topicTitle: 'Programs & Projects',
  topicDescription: 'Analyze options, build plans, monitor finances, and balance team workload.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['planning', 'projects', 'documentation'],
  dailyEligible: true,
  releasedAt: '2025-01-21T00:00:00.000Z',
  route: '/micro/build-plans',
  storyBeat: 'Create investor-quality plans without weeks of work.',
  introPrompt: "Project planning takes weeks because you're starting from blank. By the time you've thought through phases, tasks, and dependencies, the deadline is already closer than comfortable. Let's fix that.",
  steps: [
    "Identify the project that needs a roadmap",
    "Answer 4 questions to capture the full scope",
    "Get your complete Project Plan + reusable prompt",
    "Practice on a second project to prove mastery"
  ],
  promptGuidance: 'Choose a project type below or describe your own.',
  aiPrompt: BUILD_PLANS_AI_PROMPT,
  inputPlaceholder: "e.g., Annual gala, Grant launch, Program expansion...",
  quickPrompts: [
    'Annual fundraising event',
    'Grant application sprint',
    'New hire onboarding',
    'Program expansion launch'
  ]
};
